class SearchFilter extends HTMLElement {
  constructor() {
    super();
    this.filterElements = [...this.querySelectorAll('.main-blog-menu__li')];
    this.input = this.querySelector('input[type="search"]');

    this.setupEventListeners();
  }

  setupEventListeners() {
    this.input.addEventListener(
      'input',
      debounce((event) => {
        this.searchFilter(event);
      }, 300).bind(this)
    );
  }

  searchFilter = (e) => {
    e.preventDefault();
    e.target.value.length > 0 ? this.hideElements(e) : this.showHidden();
  };

  showHidden = () => {
    this.filterElements.forEach((el) => el.classList.remove('hidden'));
  };

  hideElements = (e) => {
    this.filterElements.forEach((el) => {
      if (!el.textContent.toLowerCase().includes(e.target.value.toLowerCase())) {
        el.classList.add('hidden');
      }
    });
  };
}

customElements.define('search-filter', SearchFilter);
